import { faLoader } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { ErrorContent } from '../../../../components/ErrorContent/ErrorContent'
import { useConfirmPayment } from './hooks/useConfirmPayment'

export const PaymentConfirm = (): React.ReactElement => {
  document.querySelector('#jsd-widget')?.remove()
  const { data, isLoading, isError } = useConfirmPayment()

  if (data || isLoading || !isError) {
    return (
      <div className="d-flex" style={{ height: '100vh', width: '100vw' }}>
        <FontAwesomeIcon
          icon={faLoader}
          className="m-auto text-body-secondary"
          spin={true}
          pulse={true}
          size="4x"
        />
      </div>
    )
  }

  return (
    <div className="d-flex" style={{ height: '100vh', width: '100vw' }}>
      <div className="m-auto">
        <ErrorContent
          error={{
            code: 500,
            message: 'Timeout has occured.',
            timestamp: new Date().toString(),
          }}
          style={{ marginTop: '7.5rem' }}
        />
      </div>
    </div>
  )
}
